import { message } from 'antd';
import { FC, ReactNode, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useClockContext } from '../app';
import { LayoutSite } from '../components/layout';
import { Loader } from '../components/loader';
import { get_datas, post_doremove } from '../services/api.service';
import './datas.scss';

/* -------------------------------------------------------------------------------- *\
|                               DatasPage
\* -------------------------------------------------------------------------------- */
export const DatasPage: FC<{ children?: ReactNode }> = ({ children }) =>
{
    const [loading, setLoading] = useState(true);
    const [datas, setDatas] = useState<string[]>([]);
    const [selected, setSelected] = useState<string>('');
    const clock = useClockContext();

    const navigate = useNavigate();

    /* -------------------------------------------------------------------------------- *\
    |                               refreshDatas
    \* -------------------------------------------------------------------------------- */
    const refreshDatas = async () =>
    {
        setDatas([]);
        get_datas().then((datas: string[]) =>
        {
            setDatas(datas);
        })
        .catch(error =>
        {
            message.error(String(error));
            if (error.status === 403) navigate('/login');
        });
    }
    /* -------------------------------------------------------------------------------- *\
    |                               doRemove
    \* -------------------------------------------------------------------------------- */
    const doRemove = () =>
    {
        if (!window.confirm("Are you sure to remove " + selected + '?')) return;

        setLoading(true);
        post_doremove(selected).then(() =>
        {
            message.info('Removed');
            refreshDatas();
            setSelected('');
        })
        .catch(error =>
        {
            message.error(String(error));
            if (error.status === 403) navigate('/login');
        })
        .finally(() => setLoading(false));
    }

    /* -------------------------------------------------------------------------------- *\
    |                               effects
    \* -------------------------------------------------------------------------------- */
    useEffect(() => {
        setLoading(true);
        refreshDatas().then(() => setLoading(false));
        // eslint-disable-next-line
    }, [])

    return (
        <LayoutSite>
            <div className="datas">
                {loading ? <Loader /> : <></>}
                <div className="datas__header">
                    <div>Datas managment</div>
                    <div className='calendar__header__clock'>{clock}</div>
                </div>
                <div className="datas__body">
                    <div>
                        <div className="datas__body__datas">
                            <div className="datas__body__datas__header">Datas</div>
                            <div className="datas__body__datas__table">
                            {
                                datas.map((source, is) => (
                                    <div className="datas__body__datas__table__item" key={'source' + is} onClick={() => setSelected(source)}>{source}</div>
                                ))
                            }
                            </div>
                        </div>
                    </div>
                    {
                        selected &&
                        (
                        <div>
                            <div className="selector__body__import">
                                <div className="selector__body__import__header">Selection</div>
                                <div className="selector__body__import__row">
                                    <div className="selector__body__import__row__label">datas</div>
                                    <div className="selector__body__import__row__value">{selected}</div>
                                </div>
                                <div className="selector__body__import__row">
                                    <div className="selector__body__import__row__button" onClick={() => doRemove()}>Remove</div>
                                </div>
                            </div>
                        </div>
                        )
                    }
                </div>
            </div>
        </LayoutSite>
    );
}
